import React from "react";
import "./FilterCheckbox.scss";
import { Button, ButtonType } from "../../../Components";

interface FilterCheckboxProps {
  filterOptions: string[];
  segments: string[];
  selectedSegments: string[];
  setSelectedSegments: React.Dispatch<React.SetStateAction<string[]>>;
}

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({
  filterOptions,
  segments,
  selectedSegments,
  setSelectedSegments,
}) => {
  const toggleSegment = (segment: string) => {
    setSelectedSegments((prev: string[]) =>
      prev.includes(segment) ? prev.filter(s => s !== segment) : [...prev, segment]
    );
  };

  const selectAll = () => {
    setSelectedSegments(filterOptions.filter(option => option !== "Linear TV"));
  };

  const clear = () => {
    setSelectedSegments([]);
  };

  return (
    <div className="filterCheckboxContainer">
      <div className="filterHeader">
        <Button type={ButtonType.EMPTY} size="sm" onClick={() => selectAll()}>
          Select All
        </Button>
        <Button type={ButtonType.EMPTY} size="sm" onClick={() => clear()}>
          Clear
        </Button>
      </div>
      <div className="filterOptions">
        {segments.map(segment => (
          <label key={segment} className="filterOption">
            <input
              className="inputCheckbox"
              type="checkbox"
              checked={selectedSegments.includes(segment)}
              onChange={() => toggleSegment(segment)}
            />
            {segment}
          </label>
        ))}
      </div>
    </div>
  );
};

export default FilterCheckbox;
